/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Price1Inputs */

const id_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const ms_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const da_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const de_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const en_us2_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const es_es2_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const es_mx2_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fil_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presyo`)
};

const fr_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const it_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

const hu_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ár`)
};

const nl_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs`)
};

const no_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const pl_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const pt_br2_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const pt_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const ro_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț`)
};

const fi_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinta`)
};

const sv_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const vi_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá`)
};

const tr_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat`)
};

const cs_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const bg_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const ru_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const uk_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ціна`)
};

const ar_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر`)
};

const hi_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमत`)
};

const th_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา`)
};

const ja_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格`)
};

const zh_cn2_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const zh_hant1_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`價格`)
};

const ko_tags_sortby_price1 = /** @type {(inputs: Tags_Sortby_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Tags_Sortby_Price1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_price1 = /** @type {((inputs?: Tags_Sortby_Price1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Price1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_price1(inputs)
	if (locale === "ms") return ms_tags_sortby_price1(inputs)
	if (locale === "da") return da_tags_sortby_price1(inputs)
	if (locale === "de") return de_tags_sortby_price1(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_price1(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_price1(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_price1(inputs)
	if (locale === "fil") return fil_tags_sortby_price1(inputs)
	if (locale === "fr") return fr_tags_sortby_price1(inputs)
	if (locale === "it") return it_tags_sortby_price1(inputs)
	if (locale === "hu") return hu_tags_sortby_price1(inputs)
	if (locale === "nl") return nl_tags_sortby_price1(inputs)
	if (locale === "no") return no_tags_sortby_price1(inputs)
	if (locale === "pl") return pl_tags_sortby_price1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_price1(inputs)
	if (locale === "pt") return pt_tags_sortby_price1(inputs)
	if (locale === "ro") return ro_tags_sortby_price1(inputs)
	if (locale === "fi") return fi_tags_sortby_price1(inputs)
	if (locale === "sv") return sv_tags_sortby_price1(inputs)
	if (locale === "vi") return vi_tags_sortby_price1(inputs)
	if (locale === "tr") return tr_tags_sortby_price1(inputs)
	if (locale === "cs") return cs_tags_sortby_price1(inputs)
	if (locale === "bg") return bg_tags_sortby_price1(inputs)
	if (locale === "ru") return ru_tags_sortby_price1(inputs)
	if (locale === "uk") return uk_tags_sortby_price1(inputs)
	if (locale === "ar") return ar_tags_sortby_price1(inputs)
	if (locale === "hi") return hi_tags_sortby_price1(inputs)
	if (locale === "th") return th_tags_sortby_price1(inputs)
	if (locale === "ja") return ja_tags_sortby_price1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_price1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_price1(inputs)
	return ko_tags_sortby_price1(inputs)
});
export { tags_sortby_price1 as "tags.sortBy.price" }